import { defineAsyncComponent } from 'vue'
import NtLoader from './components/general/NtLoader.vue'
import NtModuleError from './components/general/NtModuleError.vue'

export default {
  install: (app) => {
    // All components are async
    const integrations = import.meta.glob('./integrations/**/*.vue')
    for (const path in integrations) {
      const name = path.match(/\/([A-z]+).vue$/i)
      if (!name || name.length < 2) {
        continue
      }
      app.component(
        name[1],
        defineAsyncComponent({
          loader: integrations[path],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError,
        }),
      )
    }

    app.config.globalProperties.$getIntegration = function (name) {
      return app.config.globalProperties.$page.props.website.integration_instances.find((i) => i.integration.uid === name)?.config || null
    }

    app.config.globalProperties.$hasIntegration = function (name) {
      return !!app.config.globalProperties.$page.props.website.integration_instances.find((i) => i.integration.uid === name)
    }
  },
}
